module.exports = __webpack_public_path__ + "static/img/SketchPng7b3e824d451f87ae65321861a6387603107e43562a3cd8fd9155de120d125136.524ffa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SketchPng7b3e824d451f87ae65321861a6387603107e43562a3cd8fd9155de120d125136.png
// module id = ns/h
// module chunks = 1